import { Col, FloatingLabel, Row, Card, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

export default function ViewFollowUp() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [formState, setFormState] = useState({});
  const [preview, setPreview] = useState({});
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [answersText, setAnswersText] = useState({});
  const [answersFile, setAnswersFile] = useState({});

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  // ----------------------------------
  // LOAD FOLLOW-UP DETAIL
  // ----------------------------------
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/family-followup-detail/${id}`)
      .then((res) => {
        const d = res.data.followup;

        setFormState({
          dateOfVisit: d.date_of_visit,
          personName: d.family?.beneficiary_name,
          mobileNum: d.family?.mob,
          cnic: d.family?.cnic,
          identifier: d.family?.f_number,
          followUp: d.type?.name,
          comment: d.comment,
          needs: d.needs,
        });

        setPreview({
          img_1: d.family_home_image
            ? process.env.REACT_APP_IMG_URL + d.family_home_image
            : null,
          img_2: d.family_business_image
            ? process.env.REACT_APP_IMG_URL + d.family_business_image
            : null,
          img_3: d.children_school_image
            ? process.env.REACT_APP_IMG_URL + d.children_school_image
            : null,
        });

        setQuestions(d.questions || []);

        let ans = {};
        let ansTxt = {};
        let ansFile = {};

        d.questions?.forEach((q) => {
          ans[q.followup_question_id] =
            q.ans.toLowerCase() === "no" ? 0 : 1;

          if (q.ans.toLowerCase() !== "no") {
            if (q.question.file) {
              ansFile[q.followup_question_id] = q.ans;
            } else {
              ansTxt[q.followup_question_id] = q.ans;
            }
          }
        });

        setAnswers(ans);
        setAnswersText(ansTxt);
        setAnswersFile(ansFile);

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div>Loading...</div>;

  // ----------------------------------
  // UI
  // ----------------------------------
  return (
    <PageLayout>
      <Row>
              <Col xl={12}>
                <div className="mc-card">
                  <div className="mc-breadcrumb">
                    <h3 className="mc-breadcrumb-title">View Follow Up</h3>
                  </div>
                </div>
              </Col>
            </Row>
      <Form>
        <Row className="mb-3">
          <Col md={4}>
            <FloatingLabel label="Date of Visit">
              <Form.Control value={formState.dateOfVisit} readOnly />
            </FloatingLabel>
          </Col>

          <Col md={4}>
            <FloatingLabel label="Person Name">
              <Form.Control value={formState.personName} readOnly />
            </FloatingLabel>
          </Col>

          <Col md={4}>
            <FloatingLabel label="Mobile Number">
              <Form.Control value={formState.mobileNum} readOnly />
            </FloatingLabel>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <FloatingLabel label="CNIC">
              <Form.Control value={formState.cnic} readOnly />
            </FloatingLabel>
          </Col>

          <Col md={4}>
            <FloatingLabel label="Family Code">
              <Form.Control value={formState.identifier} readOnly />
            </FloatingLabel>
          </Col>

          <Col md={4}>
            <FloatingLabel label="Follow Up Status">
              <Form.Control value={formState.followUp} readOnly />
            </FloatingLabel>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FloatingLabel label="Comment">
              <Form.Control as="textarea" value={formState.comment} readOnly />
            </FloatingLabel>
          </Col>

          <Col md={6}>
            <FloatingLabel label="Needs">
              <Form.Control as="textarea" value={formState.needs} readOnly />
            </FloatingLabel>
          </Col>
        </Row>

        {/* IMAGES */}
        <Row className="mt-4">
          {Object.values(preview).map(
            (img, i) =>
              img && (
                <Col md={4} key={i}>
                  <Card>
                    <Card.Body>
                      <img
                        src={img}
                        alt="Preview"
                        style={{ width: "100%", height: "300px", objectFit: "contain" }}
                      />
                    </Card.Body>
                  </Card>
                </Col>
              )
          )}
        </Row>

        {/* QUESTIONS */}
        <Row className="mt-4">
          <Col>
            <h5>Follow-up Questions</h5>

            {questions.map((q) => (
              <Card key={q.followup_question_id} className="mb-2">
                <Card.Body>
                  <b>{q.question.question}</b>

                  <div className="mt-2">
                    <Form.Check
                      inline
                      label="Yes"
                      checked={answers[q.followup_question_id] === 1}
                      readOnly
                    />
                    <Form.Check
                      inline
                      label="No"
                      checked={answers[q.followup_question_id] === 0}
                      readOnly
                    />
                  </div>

                  {answersText[q.followup_question_id] && (
                    <Form.Control
                      className="mt-2"
                      value={answersText[q.followup_question_id]}
                      readOnly
                    />
                  )}

                  {answersFile[q.followup_question_id] && (
                    <a
                      href={
                        process.env.REACT_APP_IMG_URL +
                        answersFile[q.followup_question_id]
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="d-block mt-2"
                    >
                      View Uploaded File
                    </a>
                  )}
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>

        {/* ACTIONS
        <div className="mt-4">
          <Link to={`/edit-follow-up/${id}`}>
            <Button variant="primary">Edit Follow Up</Button>
          </Link>
        </div> */}
      </Form>
    </PageLayout>
  );
}
